import React from 'react'

interface SearchBarProps {
  placeholder?: string
  value: string
  onChange: (value: string) => void
  onClear?: () => void
  showResultsCount?: boolean
  resultsCount?: number
  resultsLabel?: string
  style?: React.CSSProperties
}

export function SearchBar({
  placeholder = "Buscar...",
  value,
  onChange,
  onClear,
  showResultsCount = false,
  resultsCount = 0,
  resultsLabel = "resultados encontrados",
  style = {}
}: SearchBarProps) {
  return (
    <div 
      className="searchbar-container"
      style={{
        marginBottom: '2rem',
        maxWidth: 1000,
        margin: '0 auto',
        padding: '0 16px', // Adiciona padding lateral para evitar corte
        boxSizing: 'border-box', // Garante que o padding seja incluído no width
        ...style
      }}
    >
      <div style={{
        position: 'relative',
        width: '100%',
        maxWidth: '600px',
        margin: '0 auto'
      }}>
        {/* Ícone de lupa */}
        <div 
          className="searchbar-icon"
          style={{
            position: 'absolute',
            left: '12px', // Reduzido para mobile
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#666',
            zIndex: 1,
            pointerEvents: 'none',
            width: '20px',
            height: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <svg
            width="16px" // Tamanho fixo para mobile
            height="16px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        
        <input
          className="searchbar-input"
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={{
            width: '100%',
            padding: '12px 16px', // Reduzido padding para mobile
            paddingLeft: '40px', // Reduzido para acomodar ícone menor
            fontSize: '16px', // Tamanho fixo para mobile
            border: '2px solid #e0e0e0',
            borderRadius: '8px',
            outline: 'none',
            transition: 'border-color 0.2s ease',
            fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            boxSizing: 'border-box', // Garante que padding seja incluído no width
            minHeight: '44px', // Altura mínima para touch
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#0072BB'
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#e0e0e0'
          }}
        />
        {value && (
          <button
            className="searchbar-clear"
            onClick={onClear}
            style={{
              position: 'absolute',
              right: '8px', // Reduzido para mobile
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'none',
              border: 'none',
              fontSize: '18px', // Tamanho fixo para mobile
              cursor: 'pointer',
              color: '#666',
              padding: '4px',
              borderRadius: '50%',
              width: '28px', // Aumentado para melhor touch
              height: '28px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.2s ease',
              minHeight: '44px', // Altura mínima para touch
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.1)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent'
            }}
          >
            ✕
          </button>
        )}
      </div>
      
      {/* Contador de resultados */}
      {showResultsCount && value && (
        <div style={{
          textAlign: 'center',
          marginTop: '0.5rem',
          color: '#666',
          fontSize: '14px', // Tamanho fixo para mobile
          padding: '0 8px', // Adiciona padding para evitar corte
        }}>
          {resultsCount} {resultsLabel}
        </div>
      )}

      {/* CSS responsivo adicional */}
      <style>{`
        @media (max-width: 768px) {
          .searchbar-container {
            padding: 0 12px !important;
          }
          .searchbar-input {
            font-size: 16px !important;
            padding: 12px 14px !important;
            padding-left: 36px !important;
            min-height: 44px !important;
          }
          .searchbar-icon {
            left: 10px !important;
            width: 16px !important;
            height: 16px !important;
          }
          .searchbar-clear {
            right: 6px !important;
            width: 26px !important;
            height: 26px !important;
            font-size: 16px !important;
          }
        }
        @media (max-width: 480px) {
          .searchbar-container {
            padding: 0 8px !important;
          }
          .searchbar-input {
            padding: 10px 12px !important;
            padding-left: 32px !important;
            font-size: 16px !important;
          }
          .searchbar-icon {
            left: 8px !important;
            width: 14px !important;
            height: 14px !important;
          }
          .searchbar-clear {
            right: 4px !important;
            width: 24px !important;
            height: 24px !important;
            font-size: 14px !important;
          }
        }
      `}</style>
    </div>
  )
} 